import axios from "axios";
import baseUrl from "./baseUrl";
import {
	CreateUserNotificationDto,
	UpdateUserNotificationDto,
} from "../models/UserNotifications";

export default class UserNotificationApi {
	static resourceUrl = baseUrl + "/user-notification";

	static async create(data: {
		accessToken: string | null;
		createDto: CreateUserNotificationDto;
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "POST",
			url: this.resourceUrl + "/create",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.accessToken,
			},
			data: data.createDto,
		});

		return response.data;
	}

	static async list(data: {
		token: string | null;
		permissionaryId: string;
		query: {};
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "GET",
			url:
				this.resourceUrl +
				"/list?q=" +
				JSON.stringify(data.query) +
				"&permissionaryId=" +
				data.permissionaryId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.token,
			},
		});

		return response.data;
	}

	static async update(data: {
		accessToken: string | null;
		id: string;
		updateDto: UpdateUserNotificationDto;
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "PUT",
			url: this.resourceUrl + "/update/" + data.id,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.accessToken,
			},
			data: data.updateDto,
		});

		return response.data;
	}

	static async delete(data: {
		accessToken: string | null;
		id: string;
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "DELETE",
			url: this.resourceUrl + "/delete/" + data.id,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.accessToken,
			},
		});

		return response.data;
	}
}
